var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.92 0H4.08C2.99792 0 1.96015 0.413323 1.195 1.14904C0.429856 1.88476 0 2.88261 0 3.92308V30.0769C0 31.1174 0.429856 32.1152 1.195 32.851C1.96015 33.5867 2.99792 34 4.08 34H29.92C31.0021 34 32.0398 33.5867 32.805 32.851C33.5701 32.1152 34 31.1174 34 30.0769V3.92308C34 2.88261 33.5701 1.88476 32.805 1.14904C32.0398 0.413323 31.0021 0 29.92 0ZM31.28 30.0769C31.28 30.4237 31.1367 30.7564 30.8817 31.0016C30.6266 31.2468 30.2807 31.3846 29.92 31.3846H4.08C3.71931 31.3846 3.37338 31.2468 3.11834 31.0016C2.86329 30.7564 2.72 30.4237 2.72 30.0769V3.92308C2.72 3.57626 2.86329 3.24364 3.11834 2.9984C3.37338 2.75316 3.71931 2.61538 4.08 2.61538H29.92C30.2807 2.61538 30.6266 2.75316 30.8817 2.9984C31.1367 3.24364 31.28 3.57626 31.28 3.92308V30.0769Z",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBig);
export default __webpack_public_path__ + "static/media/big.a13eb47eb4ecaebd8c536f31cab1f03c.svg";
export { ForwardRef as ReactComponent };